export enum WorkorderLineField {
	OrderLineId = "order_line_id",
	OrganizationId = "organization_id",
	OrderId = "order_id",
	ArticleId = "article_id",
	TurnoverGroupId = "turnover_group_id",
	CostProjectCodeId = "cost_project_code_id",
	InternalCostId = "internal_cost_id",
	ContactIdSuplier = "contact_id_suplier",
	TopmecUid = "topmec_uid",
	ArticleNumber = "article_number",
	ArticleType = "article_type",
	DeliveryDate = "delivery_date",
	IsOrdered = "is_ordered",
	IsHidePrint = "is_hide_print",
	IsSelected = "is_selected",
	OwnerId = "owner_id",
	CreatedDate = "created_date",
	ModifiedDate = "modified_date",
	CreatedBy = "created_by",
	ModifiedBy = "modified_by",
	VatCodeId = "vat_code_id",
	ArticleKind = "article_kind",
	Description = "description",
	SortOrder = "sort_order",
	IsManualInput = "is_manual_input",
	CatalogId = "catalog_id",
	PurchasePrice = "purchase_price",
	Quantity = "quantity",
	PrintQuantityOnInvoice = "print_quantity_on_invoice",
	Price = "price",
	DiscountPercentage = "discount_percentage",
	GrossTotalPrice = "gross_total_price",
	VatTotal = "vat_total",
	TotalIncludingVat = "total_including_vat",
	ExternalId = "external_id",
	DescriptionInternal = "description_internal",
	FlatRateId = "flat_rate_id",
	OrderedDate = "ordered_date",
	InternalReversalId = "internal_reversal_id",
	ExternalId2 = "external_id_2",
	IsEmptyLine = "is_empty_line",
	IsDeletedByMechanic = "is_deleted_by_mechanic",
	ExternalData = "external_data",
	UnitType = "unit_type",
	PictureListId = "picture_list_id",
	PictureId = "picture_id",
	IsDone = "is_done"
}

export enum WorkorderLineFilterType {
	All,
	Yesterday,
	Today,
	Tomorrow,
	ThisWeek
}

export enum WorkorderLineOrderType {
	Ascending,
	Descending
}

export enum WorkorderLineSortType {
	LicensePlate,
	PlanningStartDate,
	OrderNumber
}

export interface IWorkorderLineDto {
	order_line_id?: string;
	order_id?: string;
	picture_list_id?: string[];
	[key: string]: any;
}

export interface IWorkorderQuery {
	filter: WorkorderLineFilterType;
	page: number;
	order: WorkorderLineOrderType;
	search: string;
	sort: WorkorderLineSortType;
}

export interface IWorkorderLineResponse {
	data: IWorkorderLineDto[];
	maxPages: number;
}

export interface IWorkordersLinesResponse {
	currentPage: number;
	data: IWorkorderLineDto[];
	maxPages: number;
	nextpage: boolean;
}
